import { call, put } from 'redux-saga/effects'
import { getGreenhouseProfile } from '../apiModules/greenhouseProfiles'
import { greenhouseProfileEntities } from '../reducks'

export function* fetchGreenhouseProfileEntitySaga(interviewRequestId) {
  const response = yield call(getGreenhouseProfile, interviewRequestId)
  yield put(greenhouseProfileEntities.addItem(response.result.id, response.result))
  return response
}
